import React from 'react';
import { Stack, styled, Typography } from '@mui/material';
import { Button } from 'components/Button/Button';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useFormContext } from 'react-hook-form';
import { SignupFormData, SignUpUserType } from 'features/signUp/types';

interface SignUpTypeStepProps {
  onSubmit: (formData: SignupFormData) => Promise<void>;
}

export const SignUpUserTypeStep = ({ onSubmit }: SignUpTypeStepProps) => {
  const { handleSubmit, setValue } = useFormContext<SignupFormData>();
  const { translation } = useTranslationContext();

  const handleUserTypeSelected = (userType: SignUpUserType) => {
    setValue('selectedUserType', userType);
    handleSubmit(onSubmit)();
  };

  return (
    <Stack className="sign-up-type-step" spacing={4}>
      <Typography variant="h5" color="primary" id="sign-up-type-step-header" mb={3}>
        {translation('account_type_header')}
      </Typography>
      <Button variant="primary" size="xlarge" onClick={() => handleUserTypeSelected('member')}>
        {translation('my_own')}
      </Button>
      {/* Overriding spacing with marginTop to have as 24px in between these buttons to fulfill UI requirements */}
      <Button
        variant="primary"
        size="xlarge"
        sx={{ mt: 3 }}
        onClick={() => handleUserTypeSelected('caregiver')}
      >
        {translation('someone_elses')}
      </Button>
      <Typography variant="body2">{translation('account_type_body')}</Typography>
    </Stack>
  );
};
